/**
 * pw-contact-form.js — 2026-08-15: POSTs {name, email, message, orderNumber} to PageWright's
 * /api/contact, which creates a real Harness support ticket. 503 means the backend integration
 * isn't configured yet (HARNESS_SUPPORT_BASE_URL / SERVICE_KEY_HARNESS_SUPPORT not provisioned) —
 * shown as its own message with the direct-email fallback, same as leadmagnet's 429 handling gets
 * its own message rather than a generic error.
 */
(function () {
  function showStatus(el, message, isError) {
    el.textContent = message;
    el.hidden = false;
    if (isError) {
      el.setAttribute('data-error', '');
    } else {
      el.removeAttribute('data-error');
    }
  }

  // Server-issued form token (signup bot defense P2, 2026-09-28): GET /api/signup-token?ep=contact
  // on mount, sent back as `formToken`. Never blocks: any failure -> null -> post without one.
  function fetchGuardToken(backendUrl) {
    try {
      return fetch(backendUrl + '/api/signup-token?ep=contact', { method: 'GET', credentials: 'omit' })
        .then(function (res) {
          return res && res.ok ? res.json() : null;
        })
        .then(function (body) {
          return body && body.token ? body.token : null;
        })
        .catch(function () {
          return null;
        });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  document.querySelectorAll('[data-pw-contact-form]').forEach(function (form) {
    var section = form.closest('[data-backend-url]');
    var backendUrl = section ? section.getAttribute('data-backend-url') : '';
    var statusEl = form.querySelector('[data-pw-contact-status]');
    var submitBtn = form.querySelector('[data-pw-contact-submit]');
    var nameInput = form.querySelector('input[name="name"]');
    var emailInput = form.querySelector('input[name="email"]');
    var orderInput = form.querySelector('input[name="orderNumber"]');
    var messageInput = form.querySelector('textarea[name="message"]');
    var hpInput = form.querySelector('[data-pw-contact-hp]');
    var tokenPromise = fetchGuardToken(backendUrl);

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (!emailInput.value || !messageInput.value) return;

      submitBtn.disabled = true;
      statusEl.hidden = true;

      var payload = { email: emailInput.value, message: messageInput.value };
      if (nameInput && nameInput.value) payload.name = nameInput.value;
      if (orderInput && orderInput.value) payload.orderNumber = orderInput.value;

      payload.website = hpInput ? hpInput.value : '';

      tokenPromise.then(function (token) {
      if (token) payload.formToken = token;
      return fetch(backendUrl + '/api/contact', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              return { ok: res.ok, status: res.status, body: body };
            });
        })
        .then(function (result) {
          // Single-use token: always fetch a fresh one after an attempt (review fix).
          tokenPromise = fetchGuardToken(backendUrl);
          if (result.ok) {
            showStatus(statusEl, result.body.message || "Thanks — we'll get back to you soon.", false);
            form.reset();
          } else if (result.status === 429) {
            showStatus(statusEl, 'Too many requests — please wait a bit and try again.', true);
            submitBtn.disabled = false;
          } else if (result.body && /^(token_invalid|try_again|email_not_accepted|turnstile_fail)$/.test(result.body.code || '')) {
            // The guard's own, visitor-actionable refusals; fetch a fresh single-use token.
            showStatus(statusEl, result.body.message || 'Please reload the page and try again.', true);
            submitBtn.disabled = false;
          } else if (result.status === 503) {
            showStatus(
              statusEl,
              result.body.error || 'Contact form temporarily unavailable — please email help@collagesoup.com directly.',
              true,
            );
            submitBtn.disabled = false;
          } else {
            showStatus(
              statusEl,
              result.body.error || "Something went wrong — please email help@collagesoup.com directly.",
              true,
            );
            submitBtn.disabled = false;
          }
        })
        .catch(function () {
          tokenPromise = fetchGuardToken(backendUrl);
          showStatus(statusEl, 'Something went wrong — please email help@collagesoup.com directly.', true);
          submitBtn.disabled = false;
        });
      });
    });
  });
})();
